import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Id_bs$SolvuuApi0 from "./id_bs.bs.js";
import * as Fmt_bs$SolvuuRoot0 from "solvuu-root0/./fmt_bs.bs.js";
import * as Lang_var$SolvuuApi0 from "./lang_var.bs.js";
import * as Term_bs$SolvuuLang0 from "solvuu-lang0/./term_bs.bs.js";
import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";
import * as Lang_type_bs$SolvuuApi0 from "./lang_type_bs.bs.js";
import * as Lang_label_bs$SolvuuApi0 from "./lang_label_bs.bs.js";

function write__1(param) {
  return Atdgen_codec_runtime.Encode.contramap(Lang_var$SolvuuApi0.unwrap, Atdgen_codec_runtime.Encode.string, param);
}

function read__1(param) {
  return Atdgen_codec_runtime.Decode.map(Lang_var$SolvuuApi0.wrap, Atdgen_codec_runtime.Decode.string, param);
}

var write_date = Atdgen_codec_runtime.Encode.string;
var read_date = Atdgen_codec_runtime.Decode.string;
var write_env = Atdgen_codec_runtime.Encode.unit;
var read_env = Atdgen_codec_runtime.Decode.unit;
var write_intrinsic = Atdgen_codec_runtime.Encode.unit;
var read_intrinsic = Atdgen_codec_runtime.Decode.unit;
var write_lang_term = Term_bs$SolvuuLang0.write_t;
var read_lang_term = Term_bs$SolvuuLang0.read_t;
var write_meta = Atdgen_codec_runtime.Encode.unit;
var read_meta = Atdgen_codec_runtime.Decode.unit;
var write_time = Atdgen_codec_runtime.Encode.string;
var read_time = Atdgen_codec_runtime.Decode.string;

function write__7(js) {
  return Atdgen_codec_runtime.Encode.nullable(write_map, js);
}

function write_dir(js) {
  var js$1 = js;
  return Curry._1(Atdgen_codec_runtime.Encode.make(function (t) {
    return Atdgen_codec_runtime.Encode.obj(
    /* :: */
    [Atdgen_codec_runtime.Encode.field(undefined, Id_bs$SolvuuApi0.write_term, "id", t.id),
    /* :: */
    [Atdgen_codec_runtime.Encode.field(undefined, write__7, "data", t.data),
    /* [] */
    0]]);
  }), js$1);
}

function write_map(js) {
  var js$1 = js;
  return Atdgen_codec_runtime.Encode.list(function (param) {
    return Atdgen_codec_runtime.Encode.tuple2(Lang_label_bs$SolvuuApi0.write_t, write_t, param);
  }, js$1);
}

function write_t(js) {
  var js$1 = js;
  return Curry._1(write_lang_term(write_date, write_time, Id_bs$SolvuuApi0.write_blob, Id_bs$SolvuuApi0.write_job, write_t, Lang_label_bs$SolvuuApi0.write_t, write_map, write__1, Id_bs$SolvuuApi0.write_term, Lang_type_bs$SolvuuApi0.write_t, write_env, write_intrinsic, write_meta, write_dir), js$1);
}

function read__7(js) {
  return Atdgen_codec_runtime.Decode.nullable(read_map, js);
}

function read_dir(js) {
  var js$1 = js;
  return Curry._1(Atdgen_codec_runtime.Decode.make(function (json) {
    return {
      id: Atdgen_codec_runtime.Decode.decode(function (param) {
        return Atdgen_codec_runtime.Decode.field("id", Id_bs$SolvuuApi0.read_term, param);
      }, json),
      data: Atdgen_codec_runtime.Decode.decode(function (param) {
        return Atdgen_codec_runtime.Decode.field("data", read__7, param);
      }, json)
    };
  }), js$1);
}

function read_map(js) {
  var js$1 = js;
  return Atdgen_codec_runtime.Decode.list(function (param) {
    return Atdgen_codec_runtime.Decode.tuple2(Lang_label_bs$SolvuuApi0.read_t, read_t, param);
  }, js$1);
}

function read_t(js) {
  var js$1 = js;
  return Curry._1(read_lang_term(read_date, read_time, Id_bs$SolvuuApi0.read_blob, Id_bs$SolvuuApi0.read_job, read_t, Lang_label_bs$SolvuuApi0.read_t, read_map, read__1, Id_bs$SolvuuApi0.read_term, Lang_type_bs$SolvuuApi0.read_t, read_env, read_intrinsic, read_meta, read_dir), js$1);
}

var write_lang_term_future = Term_bs$SolvuuLang0.write_future;
var read_lang_term_future = Term_bs$SolvuuLang0.read_future;
var write_lang_term_error = Term_bs$SolvuuLang0.write_error;
var read_lang_term_error = Term_bs$SolvuuLang0.read_error;

function write_item(write__item) {
  return Atdgen_codec_runtime.Encode.make(function (t) {
    return Atdgen_codec_runtime.Encode.obj(
    /* :: */
    [Atdgen_codec_runtime.Encode.field(undefined, Id_bs$SolvuuApi0.write_term, "id", t.id),
    /* :: */
    [Atdgen_codec_runtime.Encode.field(undefined, function (param) {
      return Atdgen_codec_runtime.Encode.nullable(write__item, param);
    }, "data", t.data),
    /* [] */
    0]]);
  });
}

function read_item(read__item) {
  return Atdgen_codec_runtime.Decode.make(function (json) {
    return {
      id: Atdgen_codec_runtime.Decode.decode(function (param) {
        return Atdgen_codec_runtime.Decode.field("id", Id_bs$SolvuuApi0.read_term, param);
      }, json),
      data: Atdgen_codec_runtime.Decode.decode(function (param) {
        return Atdgen_codec_runtime.Decode.field("data", function (param) {
          return Atdgen_codec_runtime.Decode.nullable(read__item, param);
        }, param);
      }, json)
    };
  });
}

var write__2 = Term_bs$SolvuuLang0.write_future(Id_bs$SolvuuApi0.write_blob, Id_bs$SolvuuApi0.write_job);
var read__2 = Term_bs$SolvuuLang0.read_future(Id_bs$SolvuuApi0.read_blob, Id_bs$SolvuuApi0.read_job);
var write_future = Atdgen_codec_runtime.Encode.make(function (x) {
  return Atdgen_codec_runtime.Encode.constr1("Future", write__2, x[1]);
});
var read_future = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Future",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Future */
      [669191267, x]
    );
  }, read__2, param);
}]],
/* [] */
0]);
var write__3 = write_lang_term_error(Id_bs$SolvuuApi0.write_blob, Id_bs$SolvuuApi0.write_job, write_t, Lang_type_bs$SolvuuApi0.write_t);
var read__3 = read_lang_term_error(Id_bs$SolvuuApi0.read_blob, Id_bs$SolvuuApi0.read_job, read_t, Lang_type_bs$SolvuuApi0.read_t);
var write_error = Atdgen_codec_runtime.Encode.make(function (x) {
  return Atdgen_codec_runtime.Encode.constr1("Error", write__3, x[1]);
});
var read_error = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Error",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Error */
      [106380200, x]
    );
  }, read__3, param);
}]],
/* [] */
0]);
var read_blob_id = Id_bs$SolvuuApi0.read_blob;
var write_blob_id = Id_bs$SolvuuApi0.write_blob;
var read_job_id = Id_bs$SolvuuApi0.read_job;
var write_job_id = Id_bs$SolvuuApi0.write_job;
var read_label = Lang_label_bs$SolvuuApi0.read_t;
var write_label = Lang_label_bs$SolvuuApi0.write_t;
var read_term_id = Id_bs$SolvuuApi0.read_term;
var write_term_id = Id_bs$SolvuuApi0.write_term;
var read_type0 = Lang_type_bs$SolvuuApi0.read_t;
var write_type0 = Lang_type_bs$SolvuuApi0.write_t;
var read_var = read__1;
var write_var = write__1;
var read_fmt0 = Fmt_bs$SolvuuRoot0.read_t;
var write_fmt0 = Fmt_bs$SolvuuRoot0.write_t;
export { read_blob_id, write_blob_id, read_date, write_date, read_env, write_env, read_intrinsic, write_intrinsic, read_job_id, write_job_id, read_label, write_label, read_lang_term, write_lang_term, read_meta, write_meta, read_term_id, write_term_id, read_item, write_item, read_time, write_time, read_type0, write_type0, read_var, write_var, read_dir, write_dir, read_map, write_map, read_t, write_t, read_lang_term_future, write_lang_term_future, read_lang_term_error, write_lang_term_error, read_future, write_future, read_fmt0, write_fmt0, read_error, write_error };
/* write__2 Not a pure module */